export function getSwappedValue(shouldSwap, value1, value2) {
    return shouldSwap ? value2 : value1;
}
//# sourceMappingURL=GetSwappedValue.js.map